import CachedIcon from '@mui/icons-material/Cached';
import EditIcon from '@mui/icons-material/Edit';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { Card, CardContent, CardHeader, IconButton, Typography } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import * as React from "react";
import { connect } from "react-redux";
import { HeavyEarthLeakageSettingModel, UpdateResult } from '../../../models';
import { ApplicationState, FetchState, actionCreators, selectors } from "../../../store";
import { showUnit } from '../../../utils';
import FetchHelper from '../../FetchHelper';
import SelectHeavyEarthLeakageSettingDialog from '../../dialogs/SelectHeavyEarthLeakageSettingDialog';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles, pollingColStyle, pollingColStyleTitle } from '../../styles';

const NO_OF_POLLING_TOPIC = 6;
const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    loadingRefreshAll: [false],
    isEdit: false,
    isRefreshGroup: false,
    isDisbleRefeshBtn: true,
    isDisbleUpdateBtn: true,
    centralId: "",
    isRefreshAllCompleted: (status: number) => { },
    setIsEdit: (isEdit: boolean) => { },
    setRefreshGroup: (disabled: boolean, name: string) => { },
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => { },
}

type HeavyEarthLeakageSettingProps = {
    defaultData: HeavyEarthLeakageSettingModel | undefined;
    deviceNo?: string;
    isRefreshSuccessDeviceNo?: boolean;
    onRefreshComplete?: () => void;
};

export type PureHeavyEarthLeakageSettingProps = HeavyEarthLeakageSettingProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

const fetchId = "HEAVY_EARTH_LEAKAGE_SETTING_FETCH";
export const HeavyEarthLeakageSetting_TJ360VersionDevice = (props: PureHeavyEarthLeakageSettingProps) => {
    const { defaultData, fetchState, mainid, isRefreshAllBegin, loadingRefreshAll, isEdit, isRefreshGroup, isDisbleRefeshBtn, isDisbleUpdateBtn, centralId, deviceNo, isRefreshSuccessDeviceNo } = props;
    const { onError, onUpdate, onRefresh, onUpdateSuccess, onUpdateError, isRefreshAllCompleted, setIsEdit, setRefreshGroup, setDisabledRefreshGroupBtn } = props;
    const [openSelectDialog, setOpenSelectDialog] = React.useState(false);
    const [updateData, setUpdateData] = React.useState<any>();
    const [heavyEarthLeakageSetting, setHeavyEarthLeakageSetting] = React.useState<HeavyEarthLeakageSettingModel | null>(fetchState.data);
    const [editData, setEditData] = React.useState<HeavyEarthLeakageSettingModel>();
    const [fetchLoading, setFetchLoading] = React.useState(false);
    const [editFlg, setEditFlg] = React.useState(false);
    const [isFetchAll, setIsFetchAll] = React.useState(false);
    const [isRefreshSuccess, setIsRefreshSuccess] = React.useState(false);

    React.useEffect(() => {
        if(!isRefreshSuccessDeviceNo)
            setIsRefreshSuccess(false);
    }, [isRefreshSuccessDeviceNo]);

    // パラメータ設定
    const handleFetchParams = () => {
        const params = new Map<string, any>();
        const code = "PK";
        params.set("code", code);
        params.set("mainid", mainid);
        params.set("device_no", deviceNo);
        params.set("centralid", centralId);
        return params;
    }

    // 重漏電設定取得成功時
    const handleFetchSuccess = (data: any, action: string, isClickedRefreshBtn: boolean) => {
        setEditFlg(false);
        (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) && (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false);
        if (data) {
            const resData = {
                mainid: data.mainid,
                deviceNo: data.device_no,
                leakMa1: data.leak_ma1,
                leakMa2: data.leak_ma2,
                leakMa3: data.leak_ma3,
                leakMa4: data.leak_ma4,
                leakMa5: data.leak_ma5,
                leakMa6: data.leak_ma6,
                lastGetDatetime: data.last_get_datetime,
            } as HeavyEarthLeakageSettingModel;

            setHeavyEarthLeakageSetting(resData);
            setFetchLoading(false);
            isClickedRefreshBtn && setIsRefreshSuccess(true);
            
            if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
                isRefreshAllCompleted(isRefreshAllBegin + 1);
            }
            setRefreshGroup(false, fetchId);

            if (action === 'edit') {
                setEditData(resData);
                setOpenSelectDialog(true);
            }
        }
    };

    const handleError = (success: boolean, data: any, error: any) => {
        onError(success, data, error);
        setEditFlg(false);
        (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) && (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false);
        setFetchLoading(false);
        setIsRefreshSuccess(false);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        setRefreshGroup(false, fetchId);
    }

    const handleRefresh = () => {
        setFetchLoading(true);
        setIsRefreshSuccess(false);
        const params = handleFetchParams();
        onRefresh(params, fetchId + deviceNo);
    };

    const handleRefreshSuccess = (data: any) => {
        editFlg ? handleFetchSuccess(data, 'edit', true) : handleFetchSuccess(data, 'view', true);
        props.onRefreshComplete?.();
    }

    const [updateDialogTitle, setUpdateDialogTitle] = React.useState('');
    const handleEdit = () => {
        setEditFlg(true);
        const params = handleFetchParams();
        onRefresh(params, fetchId + deviceNo);
        setUpdateDialogTitle(`重漏電設定`);
        setFetchLoading(true);
        setIsRefreshSuccess(false);
    };

    const handleUpdateEquipmentOk = (request: any) => {
        setOpenSelectDialog(false);
        const code = "PL";
        const requestData = {
            mainid: request.mainid,
            device_no: deviceNo,
            centralid: centralId,
            leak_ma1: request.leak_ma1,
            leak_ma2: request.leak_ma2,
            leak_ma3: request.leak_ma3,
            leak_ma4: request.leak_ma4,
            leak_ma5: request.leak_ma5,
            leak_ma6: request.leak_ma6,
        }
        onUpdate(code, mainid, requestData);
        setUpdateData(request);
        setFetchLoading(true);
        setIsRefreshSuccess(false);
    };

    const handleUpdateEquipmentCancel = () => {
        setOpenSelectDialog(false);
    };

    const handleUpdateSuccess = (success: boolean, data: any, error: any) => {
        const result = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            resultCode: data.result_code,
        } as UpdateResult;
        if (result.resultCode === '0') {
            handleFetchSuccess(updateData, 'view', true);
            onUpdateSuccess();
        } else {
            handleUpdateError(success, data, error);
        }
    }

    const handleUpdateError = (success: boolean, data: any, error: any) => {
        setFetchLoading(false);
        setIsRefreshSuccess(true);
        onUpdateError(success, data, error);
    }

    const refreshAll = () => {
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
            console.log("fetch No:______" + isRefreshAllBegin);
            handleRefresh();
        }
        if (isRefreshGroup === true) {
            handleRefresh();
            setFetchLoading(true);
            setIsRefreshSuccess(false);
        }
        if (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) {
            setFetchLoading(true);
            setIsRefreshSuccess(false);
        }
        isRefreshAllBegin > 0 || isRefreshGroup ? setIsFetchAll(true) : setIsFetchAll(false);
    }
    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin, loadingRefreshAll, isRefreshGroup]);

    const handleDisabledRefreshAll = () => {
        if (!fetchLoading) {
            setDisabledRefreshGroupBtn(false, fetchId);
        } else {
            setDisabledRefreshGroupBtn(true, fetchId);
        }
    }
    // eslint-disable-next-line
    React.useEffect(handleDisabledRefreshAll, [fetchLoading]);

    React.useEffect(() => {
        editFlg ? setIsEdit(true) : setIsEdit(false);
        // eslint-disable-next-line
    }, [editFlg])

    React.useEffect(() => {
        defaultData && handleFetchSuccess(defaultData, 'view', false);
        if(!defaultData) {
            setHeavyEarthLeakageSetting(null);
        }
        // eslint-disable-next-line
    }, [defaultData]);

    return (
        <>
            {/* device00 */}
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="edit" onClick={handleEdit} disabled={isDisbleUpdateBtn || isEdit || fetchLoading || isFetchAll}>
                                <EditIcon fontSize="medium" style={isDisbleUpdateBtn || isEdit === true || fetchLoading || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                            <IconButton aria-label="refresh" onClick={handleRefresh} disabled={isDisbleRefeshBtn || editFlg || fetchLoading || isFetchAll}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || editFlg === true || fetchLoading || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title={`重漏電設定`}
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {fetchLoading ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>漏電電流1</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>漏電電流2</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>漏電電流3</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>漏電電流4</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>漏電電流5</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>漏電電流6</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>漏電電流1</td>
                                    <td style={pollingColStyle}>{heavyEarthLeakageSetting?.leakMa1}{showUnit(heavyEarthLeakageSetting?.leakMa1, "mA")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>漏電電流2</td>
                                    <td style={pollingColStyle}>{heavyEarthLeakageSetting?.leakMa2}{showUnit(heavyEarthLeakageSetting?.leakMa2, "mA")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>漏電電流3</td>
                                    <td style={pollingColStyle}>{heavyEarthLeakageSetting?.leakMa3}{showUnit(heavyEarthLeakageSetting?.leakMa3, "mA")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>漏電電流4</td>
                                    <td style={pollingColStyle}>{heavyEarthLeakageSetting?.leakMa4}{showUnit(heavyEarthLeakageSetting?.leakMa4, "mA")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>漏電電流5</td>
                                    <td style={pollingColStyle}>{heavyEarthLeakageSetting?.leakMa5}{showUnit(heavyEarthLeakageSetting?.leakMa5, "mA")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>漏電電流6</td>
                                    <td style={pollingColStyle}>{heavyEarthLeakageSetting?.leakMa6}{showUnit(heavyEarthLeakageSetting?.leakMa6, "mA")}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{heavyEarthLeakageSetting?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >
            {
                openSelectDialog ? (
                    <SelectHeavyEarthLeakageSettingDialog
                        isOpen={true}
                        onOK={(data) => handleUpdateEquipmentOk(data)}
                        onCancel={handleUpdateEquipmentCancel}
                        data={editData}
                        dialogTitle={updateDialogTitle}
                    />
                ) : (
                    <div />
                )
            }
            <FetchHelper fetchId={fetchId + deviceNo} onComplete={(success, data, error) => success ? handleRefreshSuccess(data) : handleError(success, data, error)} />
            <FetchHelper fetchId="UPDATE_HEAVY_EARTH_LEAKAGE_SETTING" method="POST" onComplete={(success, data, error) => success ? handleUpdateSuccess(success, data, error) : handleUpdateError(success, data, error)} />
        </>
    );
};
const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});
const mapDispatchToProps = {
    onUpdate: (code: string, mainid: string, data: any) => actionCreators.fetch("UPDATE_HEAVY_EARTH_LEAKAGE_SETTING", `/polling-nrf/set?code=${code}`, 'POST', data, false, true),
    onRefresh: (params: any, fetchId: string) => actionCreators.fetch(fetchId, `/polling-nrf/get`, "GET", params),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: `重漏電設定取得`,
            body: "重漏電設定情報取得できませんでした。",
        }),
    onUpdateSuccess: () =>
        actionCreators.showMessage({
            type: "info",
            title: `重漏電設定変更`,
            body: "重漏電設定を変更しました。",
        }),
    onUpdateError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: `重漏電設定変更`,
            body: "重漏電設定を変更できませんでした。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HeavyEarthLeakageSetting_TJ360VersionDevice);

